<template>
  <span v-html="svg"></span>
</template>

<script>
  export default {
    name: 'svgIcon',

    props: {
      basePath: {
        type: String,
        default: 'dist/img'
      },
      name: {
        type: String,
        required: true
      },
      size: {
        default: 16
      }
    },

    computed: {
      /**
       * Computed icon link
       */
      svg() {
        return `<svg style="width: ${ this.size }px; height: ${ this.size }px" class="icon"><use xlink:href="${location.origin}/${ this.basePath }/icons.svg#${ this.name }"></use></svg>`
      }
    }
  }
</script>

<style>
	.icon {
		fill: none;
		stroke: currentColor;
		stroke-width: 2;
		stroke-linecap:round; stroke-linejoin: round;
		stroke-miterlimit: 10
	}
</style>



// WEBPACK FOOTER //
// SVGIcon.vue?e4b0d554